import React from 'react'
import ArticleTags from 'components/shared/ArticleTags'

export default function ArticleCategories({ categories }) {
  if (categories < 1 || categories === undefined) return null
  return <ArticleTags categories={categories} page="article" />
}
